import de from './translations/de.js';
import en from './translations/en.js';

const exportTranslations = {
  de,
  en,
};
export default exportTranslations;
